(() => {
  if (customElements.get('buddha-wholesale-initialized')) return;
  // Script can be included by more than one section in the theme editor.
  customElements.define('buddha-wholesale-initialized', class extends HTMLElement {});
  function initialize(root = document) {
    root.querySelectorAll('[data-wholesale-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const button = form.querySelector('[data-wholesale-submit]');
      const alert = form.querySelector('[data-wholesale-error]');
      const success = form.parentElement.querySelector('[data-wholesale-success]');
      const originalButton = button.innerHTML;
      let busy = false;
      let submissionId;
      const clearErrors = () => {
        alert.hidden = true;
        form.querySelectorAll('[aria-invalid]').forEach((field) => field.removeAttribute('aria-invalid'));
        form.querySelectorAll('[data-error-for]').forEach((error) => { error.hidden = true; error.textContent = ''; });
      };
      // Sales channels: checkboxes, at least one required. Native validity so reportValidity() and no-JS fallback agree.
      const channelGroup = form.querySelector('[data-wholesale-channels]');
      const channels = channelGroup ? [...channelGroup.querySelectorAll('input[type="checkbox"]')] : [];
      const syncChannels = () => {
        const any = channels.some((c) => c.checked);
        channels.forEach((c) => c.setCustomValidity(any ? '' : channelGroup.dataset.msgRequired || 'Selecciona al menos un canal de venta.'));
      };
      channels.forEach((c) => c.addEventListener('change', syncChannels));
      syncChannels();
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        clearErrors();
        busy = true;
        button.disabled = true;
        button.textContent = form.dataset.msgSending || 'Enviando…';
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          // Reuse on retries: a network timeout must not create a second request.
          submissionId ||= crypto.randomUUID();
          const data = new FormData(form);
          data.set('submission_id', submissionId);
          const response = await fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'application/json' }, signal: controller.signal });
          const result = response.headers.get('content-type')?.includes('application/json') ? await response.json() : null;
          if (!response.ok || !result?.ok) {
            for (const [name, message] of Object.entries(result?.errors || {})) {
              const error = [...form.querySelectorAll('[data-error-for]')].find((el) => el.dataset.errorFor === name);
              if (error) { error.textContent = message; error.hidden = false; }
              [...form.elements].filter((el) => el.name === name).forEach((el) => el.setAttribute('aria-invalid', 'true'));
            }
            throw new Error(result?.message || form.dataset.msgError || 'No hemos podido enviar la solicitud. Inténtalo de nuevo en unos minutos.');
          }
          form.hidden = true;
          success.hidden = false;
          success.focus();
          form.reset();
          syncChannels();
        } catch (error) {
          alert.textContent = error.name === 'AbortError' ? (form.dataset.msgTimeout || 'El envío está tardando más de lo esperado. Vuelve a intentarlo; evitaremos duplicar tu solicitud.') : error.message;
          alert.hidden = false;
          const invalid = form.querySelector('[aria-invalid="true"]');
          (invalid || alert).focus();
        } finally {
          clearTimeout(timeout);
          busy = false;
          button.disabled = false;
          button.innerHTML = originalButton;
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
